import { FeatureFlagAdminItem, FeatureFlagAdminList, FeatureFlagsEval, FlagKeyQuery, UpsertFeatureFlag } from '../interfaces/flags';
import { empty, json, problem, type PathDef } from '../../util/pathDef';

export const flagsEvalGet: PathDef = {
  method: 'get',
  path: '/flags/eval',
  handler: 'domains/bff/src/flags/eval/index.handler',
  tags: ['flags'],
  summary: 'Evaluate feature flags for the caller',
  description: 'Returns key→boolean for live flags. Eval order: email override → datasource override → global enabled. Uses JWT email + datasource.',
  security: 'bearerAuth',
  responses: {
    200: json('Evaluated flags', FeatureFlagsEval),
    401: problem('Unauthorized'),
  },
};

export const flagsListGet: PathDef = {
  method: 'get',
  path: '/admin/flags',
  handler: 'domains/bff/src/admin/flags/list/index.handler',
  tags: ['admin'],
  summary: 'List feature flags',
  description: 'Registry metadata plus live Dynamo targeting. Requires an Admin Center JWT (`isAdminCentral`).',
  security: 'bearerAuth',
  responses: {
    200: json('Admin flag list', FeatureFlagAdminList),
    401: problem('Unauthorized'),
  },
};

export const flagsPut: PathDef = {
  method: 'put',
  path: '/admin/flags/by-key',
  handler: 'domains/bff/src/admin/flags/put/index.handler',
  tags: ['admin'],
  summary: 'Upsert a feature flag',
  description:
    'Sets global enabled plus optional datasource/email overrides for `?key=`. Eval order: email > datasource > global. New keys require owner + expectedRemovalDate. Omitted override arrays clear targeting.',
  security: 'bearerAuth',
  query: FlagKeyQuery,
  request: UpsertFeatureFlag,
  responses: {
    200: json('Updated flag', FeatureFlagAdminItem),
    400: problem('Invalid request'),
    401: problem('Unauthorized'),
    409: problem('Version conflict or flag already exists'),
  },
};

export const flagsDelete: PathDef = {
  method: 'delete',
  path: '/admin/flags/by-key',
  handler: 'domains/bff/src/admin/flags/delete/index.handler',
  tags: ['admin'],
  summary: 'Soft-delete a feature flag',
  description: 'Tombs the Dynamo row (deletedAt). Key is passed as `?key=` so `/` in keys is supported.',
  security: 'bearerAuth',
  query: FlagKeyQuery,
  responses: {
    204: empty('Flag soft-deleted'),
    400: problem('Invalid request'),
    401: problem('Unauthorized'),
  },
};

export const flagsPaths: PathDef[] = [flagsEvalGet, flagsListGet, flagsPut, flagsDelete];
